import React, { useCallback, useEffect, useRef, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import {
  capitalizeFirstLetter,
  checkArray,
  checkNull,
  createMultiSelectOptions,
  createSelectOptions,
  createSelectTwoOptions,
  decimalValue,
  getMerchantCurrencySymbol,
  pluckArray,
  removeUnderScore,
} from "../../../../../helpers";
import ErrorContainer from "../../../../Components/ErrorContainer";
import ModelContainer from "../../../../Components/ModelContainer";
import {
  changeMenuValue,
  deleteMenuBundleItemModifier,
  deleteMenuItemModifier,
  editMenuBundleItemModifier,
  getBundleModifierForCopy,
  getCopyBundleModifier,
  getCostPerMenuItem,
  getMenuItemCa,
  getMenuItemModifiers,
  getMenuMeasurementUnit,
  getMenuMultiUnit,
  getMenuUnitPrice,
  menuInitialValue,
  saveCopyBundleModifier,
  saveMenuItemModifier,
} from "../../../../../Redux/actions";
import GroupSelect from "../../../../Components/GroupSelect";
import GroupInput from "../../../../Components/GroupInput";
import GroupSelectTwo from "../../../../Components/GroupSelectTwo";
import GroupMultiSelect from "../../../../Components/GroupMultiSelect";

const BundledModifiers = (props) => {
  const { id, item_modifiers_details } = props;
  const history = useHistory();
  const dispatch = useDispatch();

  const user_details = useSelector((state) => state.authReducer.user_details);
  const merchantCurrency = getMerchantCurrencySymbol(user_details);
  const {
    modifierItemModal,
    item_ca_details,
    measurement_unit_details,
    copyModifierModal,
    copy_modifier_details,
  } = useSelector((state) => state.menuReducer);

  // useEffect(() => {
  //   return () => {
  //     dispatch(menuInitialValue());
  //   };
  // }, []);

  useEffect(() => {
    const measureUnitPrice =
      item_modifiers_details?.unit_price_detail?.measurement_price;
    if (checkNull(measureUnitPrice, false)) {
      if (modifierItemInputForm?.measurement_choice_id == 1) {
        modifierItemChangeInputHandler("unit_price", measureUnitPrice);
      }
    }
    const tempMeasureUnitPrice =
      item_modifiers_details?.temp_unit_price_detail?.measurement_price;
    if (checkNull(tempMeasureUnitPrice, false)) {
      modifierItemChangeInputHandler("temp_unit_price", tempMeasureUnitPrice);
    }
    const multiplierVal = item_modifiers_details?.multiplier_detail?.multiplier;
    if (checkNull(multiplierVal, false)) {
      modifierItemChangeInputHandler("conversion_multiplier", multiplierVal);
    }
    const costPerItemVal = item_modifiers_details?.cost_per_menu_item;
    if (
      checkArray(costPerItemVal) &&
      costPerItemVal?.[0]?.id == modifierItemInputForm?.bundle_menu_item_id
    ) {
      modifierItemChangeInputHandler("unit_cost", costPerItemVal?.[0]?.amount);
    }
  }, [item_modifiers_details]);

  const initialModifierItemForm = {
    bundle_menu: "",
    main_menu_id: id,
    modified_item: "",
    modifier_name: "",
    modifier_group_id: "",
    menu_item_id: "",
    type: "",
    action: "",
    recipe_id: "",
    ingredient_id: "",
    bundle_menu_item_id: "",
    number_of_servings: "",
    measurement_choice_id: "",
    measurement_unit_id: "",
    unit_price: "",
    conversion_multiplier: "",
    amount_used: "",
    unit_cost: "",
    modifier_price: "",
  };

  const modifierItemSchema = yup
    .object({
      bundle_menu: yup.string(),
      main_menu_id: yup.string().required(),
      modified_item: yup.string().required(),
      modifier_name: yup.string().required(),
      modifier_group_id: yup.string().required(),
      menu_item_id: yup.string().required(),
      type: yup.string().required(),
      action: yup.string().required(),
      recipe_id: yup.string().when("recipe", {
        is: "ingredient",
        then: yup.string().required(),
      }),
      ingredient_id: yup.string().when("type", {
        is: "ingredient",
        then: yup.string().required(),
      }),
      bundle_menu_item_id: yup.string().when("type", {
        is: "menu_item",
        then: yup.string().required(),
      }),
      number_of_servings: yup.string(),
      measurement_choice_id: yup.string(),
      measurement_unit_id: yup.string(),
      unit_price: yup.string(),
      conversion_multiplier: yup.string(),
      amount_used: yup.string(),
      unit_cost: yup.string(),
      modifier_price: yup.string(),
    })
    .required();

  const {
    register: modifierItemReg,
    formState: { errors: modifierItemErrors },
    handleSubmit: modifierItemSubmit,
    control: modifierItemControl,
    setValue: modifierItemSetValue,
    reset: modifierItemReset,
    trigger: modifierItemTrigger,
  } = useForm({
    resolver: yupResolver(modifierItemSchema),
    defaultValues: initialModifierItemForm,
    mode: "all",
    reValidateMode: "onChange",
  });

  const [modifierItemInputForm, setModifierItemInputForm] = useState(
    initialModifierItemForm
  );

  const initialModifierItemModalState = (
    resetVal = initialModifierItemForm
  ) => {
    modifierItemReset(resetVal);
    setModifierItemInputForm(resetVal);
  };

  const closeModifierItemModal = useCallback(
    (value) => {
      dispatch(changeMenuValue("modifierItemModal", value));
      dispatch(changeMenuValue("edit_pricings_details", null));
      initialModifierItemModalState();
    },
    [modifierItemModal, modifierItemInputForm]
  );

  const submitModifierItemModal = (data) => {
    if (data) {
      data.bundle_menu =
        item_modifiers_details?.menu_item?.menu_item_type == "bundled" ? 1 : 0;
      dispatch(saveMenuItemModifier(data));
    }
  };

  const modifierItemChangeInputHandler = (input, value) => {
    if (input == "recipe_id" && checkNull(value, false)) {
      dispatch(getMenuItemCa(`/${value}`));
    }
    if (input == "ingredient_id" && checkNull(value, false)) {
      dispatch(getMenuMeasurementUnit(`/${value}`));
    }
    if (input == "bundle_menu_item_id" && checkNull(value, false)) {
      dispatch(getCostPerMenuItem({ menu_item_id: [value] }));
    }
    if (
      input == "measurement_unit_id" &&
      checkNull(value, false) &&
      checkNull(modifierItemInputForm?.ingredient_id, false) &&
      checkNull(modifierItemInputForm?.measurement_choice_id, false) &&
      modifierItemInputForm?.measurement_choice_id == 1
    ) {
      dispatch(
        getMenuUnitPrice({
          mu_id: value,
          ing_id: modifierItemInputForm?.ingredient_id,
        })
      );
    }
    if (
      input == "measurement_unit_id" &&
      checkNull(value, false) &&
      checkNull(modifierItemInputForm?.temp_measurement_unit_id, false) &&
      checkNull(modifierItemInputForm?.measurement_choice_id, false) &&
      modifierItemInputForm?.measurement_choice_id == 2
    ) {
      dispatch(
        getMenuMultiUnit(
          {
            from_id: modifierItemInputForm?.temp_measurement_unit_id,
            to_id: value,
          },
          "multiplier_detail",
          "item_modifiers_details"
        )
      );
    }
    if (
      input == "temp_measurement_unit_id" &&
      checkNull(value, false) &&
      checkNull(modifierItemInputForm?.ingredient_id, false)
    ) {
      dispatch(
        getMenuUnitPrice(
          {
            mu_id: value,
            ing_id: modifierItemInputForm?.ingredient_id,
          },
          "temp_unit_price_detail",
          "item_modifiers_details"
        )
      );
    }
    if (
      input == "conversion_multiplier" &&
      checkNull(value, false) &&
      checkNull(modifierItemInputForm?.temp_unit_price, false)
    ) {
      modifierItemChangeInputHandler(
        "unit_price",
        decimalValue(
          parseFloat(value) *
            parseFloat(checkNull(modifierItemInputForm?.temp_unit_price, 0)),
          2,
          ""
        )
      );
    }
    if (input == "number_of_servings" && checkNull(value, false)) {
      modifierItemChangeInputHandler(
        "unit_cost",
        decimalValue(
          parseFloat(value) * parseFloat(item_ca_details?.rCpr ?? 0),
          2,
          ""
        )
      );
    }
    if (input == "unit_amount" && checkNull(value, false)) {
      modifierItemChangeInputHandler(
        "unit_cost",
        decimalValue(
          parseFloat(value) *
            parseFloat(checkNull(modifierItemInputForm?.unit_price, 0)),
          2,
          ""
        )
      );
    }
    if (
      input == "amount_used" &&
      checkNull(value, false) &&
      checkNull(modifierItemInputForm?.measurement_choice_id, false) &&
      modifierItemInputForm?.measurement_choice_id == 2
    ) {
      modifierItemChangeInputHandler(
        "unit_cost",
        decimalValue(
          parseFloat(value) *
            parseFloat(checkNull(modifierItemInputForm?.unit_price, 0)),
          2,
          ""
        )
      );
    }
    modifierItemSetValue(input, value);
    setModifierItemInputForm((prevState) => ({
      ...prevState,
      [input]: value,
    }));
  };

  // const editModifierItemHandler = (modifierItemId) => {
  //   dispatch(getEditMenuEditPricings(`/${id}/${modifierItemId}`));
  // };

  const getErrorMsgForModifierItem = (input) => {
    let res = null;
    const errorMsg = modifierItemErrors?.[input];
    if (checkNull(errorMsg)) {
      res = <ErrorContainer errors={modifierItemErrors} name={input} />;
    }
    return res;
  };

  const getModifierNameAccType = (modifierObj) => {
    let res = "N/A";
    if (modifierObj?.type == "ingredient") {
      res = checkNull(modifierObj?.Ingredient?.ingredient_name, "N/A");
    } else if (modifierObj?.type == "menu_item") {
      res = checkNull(modifierObj?.ModifierMenuItem?.menu_item_name, "N/A");
    } else if (modifierObj?.type == "recipe") {
      res = checkNull(modifierObj?.Recipe?.recipe_name, "N/A");
    }
    return res;
  };

  const getModifierAmountAccType = (modifierObj) => {
    let res = "N/A";
    if (modifierObj?.type == "ingredient") {
      res = `${decimalValue(
        modifierObj?.amount_per_item ?? 0,
        4,
        merchantCurrency
      )} ${modifierObj?.MeasurementUnit?.fullname}`;
    } else if (modifierObj?.type == "recipe") {
      res = `${decimalValue(
        modifierObj?.amount_per_item ?? 0,
        4,
        merchantCurrency
      )} Serving`;
    } else if (modifierObj?.type == "menu_item") {
      res =
        modifierObj?.action == "size"
          ? `${decimalValue(
              modifierObj?.amount_per_item ?? 0,
              2,
              merchantCurrency
            )} x Components`
          : modifierObj?.action == "discount"
          ? `${decimalValue(
              modifierObj?.amount_per_item ?? 0,
              2,
              merchantCurrency
            )} x Menu Items`
          : "N/A";
    }
    return res;
  };

  const getBundleActionPrice = (modifierObj) => {
    let res = "N/A";
    if (modifierObj?.action_price == "add") {
      res = decimalValue(modifierObj?.amount ?? 0, 2, merchantCurrency);
    } else {
      res = `-${decimalValue(modifierObj?.amount ?? 0, 2, merchantCurrency)}`;
    }
    return res;
  };

  const editBundleModifiers = (modifierId, modifierType) => {
    dispatch(editMenuBundleItemModifier(`/${modifierId}/${modifierType}`));
  };

  const deleteModifiers = (modifierId) => {
    let res = null;
    dispatch(
      deleteMenuItemModifier({
        menu_item_id: id,
        id: modifierId,
      })
    );
    return res;
  };
  const deleteBundleModifiers = (modifierId, modifierType) => {
    let res = null;
    dispatch(
      deleteMenuBundleItemModifier({
        menu_item_id: id,
        id: modifierId,
        modified_item: modifierType,
      })
    );
    return res;
  };

  const getModifierList = () => {
    let res = null;
    if (checkArray(item_modifiers_details?.modifiers)) {
      res = item_modifiers_details?.modifiers.map((modifier) => {
        return (
          <tr class="menuitem_row">
            <td>
              <strong>
                <span> {checkNull(modifier?.modifier_name)} </span>
              </strong>
              <br />{" "}
              {checkNull(
                item_modifiers_details?.modifier_groups?.[
                  modifier?.modifier_group_id
                ]
              )}
            </td>
            <td>{removeUnderScore(checkNull(modifier?.type))}</td>
            <td>{getModifierNameAccType(modifier)} </td>
            <td>{checkNull(modifier?.action)} </td>
            <td>{getModifierAmountAccType(modifier)} </td>
            <td>
              {decimalValue(
                modifier?.item_component_cost ?? 0,
                5,
                merchantCurrency
              )}
            </td>
            <td>
              {modifier?.action == "remove"
                ? `-${decimalValue(
                    modifier?.modifier_price ?? 0,
                    5,
                    merchantCurrency
                  )}`
                : decimalValue(
                    modifier?.modifier_price ?? 0,
                    5,
                    merchantCurrency
                  )}{" "}
            </td>
            <td>
              <a
                class="circle_icon editModifierBundle"
                title="Edit"
                val="209703"
                onClick={() => deleteModifiers(modifier?.id)}
              >
                <i class="iconSprites edit-icon"></i>
              </a>
              <a
                class="circle_icon red deleteModifierBundle"
                title="Delete"
                val="209703"
                href="#_"
              >
                <i class="iconSprites delete-icon"></i>
              </a>
            </td>
          </tr>
        );
      });
    }
    return res;
  };

  const getBundleModifierList = () => {
    let res = null;
    if (checkArray(item_modifiers_details?.bundle_item_modifiers)) {
      res = item_modifiers_details?.bundle_item_modifiers.map(
        (bunModifiers) => {
          if (checkArray(bunModifiers?.bundled_menu_item)) {
            return bunModifiers?.bundled_menu_item.map((modifier) => {
              return (
                <tr class="menuitem_row">
                  <td>
                    <strong>
                      <span> {checkNull(modifier?.modifier_name)} </span>
                    </strong>
                    <br />{" "}
                    {checkNull(
                      item_modifiers_details?.modifier_groups?.[
                        modifier?.modifier_group_id
                      ]
                    )}
                  </td>
                  <td>Menu Item</td>
                  <td>
                    {checkNull(modifier?.menu_item2?.menu_item_name, "N/A")}{" "}
                  </td>
                  <td>
                    {capitalizeFirstLetter(checkNull(modifier?.action_price))}{" "}
                  </td>
                  <td>{checkNull(modifier?.modifier_price)} </td>
                  <td>{getBundleActionPrice(modifier)}</td>
                  <td>
                    {decimalValue(
                      modifier?.modifier_price ?? 0,
                      5,
                      merchantCurrency
                    )}
                  </td>
                  <td>
                    <a
                      class="circle_icon editModifierBundle"
                      title="Edit"
                      val="209703"
                      onClick={() =>
                        editBundleModifiers(
                          modifier?.id,
                          modifier?.modified_item
                        )
                      }
                    >
                      <i class="iconSprites edit-icon"></i>
                    </a>
                    <a
                      class="circle_icon red deleteModifierBundle"
                      title="Delete"
                      val="209703"
                      onClick={() =>
                        deleteBundleModifiers(
                          modifier?.id,
                          modifier?.modified_item
                        )
                      }
                    >
                      <i class="iconSprites delete-icon"></i>
                    </a>
                  </td>
                </tr>
              );
            });
          }
        }
      );
    }
    return res;
  };

  const getStandardModifierList = () => {
    let res = null;
    if (checkArray(item_modifiers_details?.standard_modifiers)) {
      res = item_modifiers_details?.standard_modifier.map((modifier) => {
        return (
          <tr class="menuitem_row">
            <td>
              <strong>
                <span> {checkNull(modifier?.name)} </span>
              </strong>
              <br /> {checkNull(modifier?.modifier_class?.name)}
            </td>
            <td>
              <a
                class="circle_icon editModifierBundle"
                title="Edit"
                val="209703"
                href="#_"
              >
                <i class="iconSprites edit-icon"></i>
              </a>
              <a
                class="circle_icon red deleteModifierBundle"
                title="Delete"
                val="209703"
                onClick={() => deleteModifiers(modifier?.id)}
              >
                <i class="iconSprites delete-icon"></i>
              </a>
            </td>
          </tr>
        );
      });
    }
    return res;
  };

  // copy modifier bundle
  const initialCopyModifierForm = {
    main_menu_id: id,
    menu_item_id: "",
    modifier_id: [],
  };

  const copyModifierSchema = yup
    .object({
      main_menu_id: yup.string(),
      menu_item_id: yup.string(),
      modifier_id: yup.array(),
    })
    .required();

  const {
    register: copyModifierReg,
    formState: { errors: copyModifierErrors },
    handleSubmit: copyModifierSubmit,
    control: copyModifierControl,
    setValue: copyModifierSetValue,
    reset: copyModifierReset,
    trigger: copyModifierTrigger,
  } = useForm({
    resolver: yupResolver(copyModifierSchema),
    defaultValues: initialCopyModifierForm,
    mode: "all",
    reValidateMode: "onChange",
  });

  const [copyModifierInputForm, setCopyModifierInputForm] = useState(
    initialCopyModifierForm
  );

  const initialCopyModifierModalState = (
    resetVal = initialCopyModifierForm
  ) => {
    copyModifierReset(resetVal);
    setCopyModifierInputForm(resetVal);
  };

  const closeCopyModifierModal = useCallback(
    (value) => {
      dispatch(changeMenuValue("copyModifierModal", value));
      if (value) {
        dispatch(getCopyBundleModifier(`/${id}`));
      }
      initialCopyModifierModalState();
    },
    [copyModifierModal, copyModifierInputForm]
  );

  const submitCopyModifierModal = (data) => {
    if (data) {
      data.modifier_id = pluckArray(data.modifier_id, "value");
      dispatch(saveCopyBundleModifier(`/${id}`, data));
    }
  };

  const copyModifierChangeInputHandler = (input, value) => {
    if (input == "menu_item_id") {
      copyModifierChangeInputHandler("modifier_id", []);
      dispatch(getBundleModifierForCopy(`/${value}`));
    }
    copyModifierSetValue(input, value);
    setCopyModifierInputForm((prevState) => ({
      ...prevState,
      [input]: value,
    }));
  };

  const getErrorMsgForCopyModifier = (input) => {
    let res = null;
    const errorMsg = modifierItemErrors?.[input];
    if (checkNull(errorMsg)) {
      res = <ErrorContainer errors={modifierItemErrors} name={input} />;
    }
    return res;
  };

  return (
    <>
      {console.log("modifierItemErrors", modifierItemErrors)}
      <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
        <div class="container px-0">
          <div class="row mx-0">
            <div class="container px-0">
              <div class="row mx-0">
                <div class="container px-0">
                  <div class="shadowclass">
                    <div class="col-12">
                      <h4 class="event-alert"> Custom Modifiers </h4>
                      <p>
                        Create custom modifiers specific to this Menu Item using
                        existing ingredients & Recipes along with amounts
                        added/removed and any price Increase/decrease associated
                        with it.
                      </p>
                    </div>
                    <div class="table-responsive min-wd-1200">
                      <table
                        class="checklist-table inventory_table remove-space categories_table"
                        width="100%"
                        cellspacing="0"
                        cellpadding="0"
                      >
                        <thead>
                          <tr>
                            <th> Modifier Name &amp; Group </th>
                            <th> Type </th>
                            <th> Component Item Name </th>
                            <th> Action </th>
                            <th>
                              Amount Used <br />
                              Per Menu Item Qty
                            </th>
                            <th>
                              Cost Per <br /> Menu Item
                            </th>
                            <th> Modifier Price </th>
                            <th class="action-td"> Actions </th>
                          </tr>
                        </thead>
                        <tbody>
                          {getModifierList()}
                          {getBundleModifierList()}
                        </tbody>
                      </table>
                    </div>
                    <button
                      class="btn green-btn-revert add-plus addSp"
                      id="addCount"
                      type="button"
                      onClick={() => closeModifierItemModal(true)}
                    >
                      <i class="i-icon"> </i> Add Custom Modifier
                    </button>
                    <button
                      onClick={() => closeCopyModifierModal(true)}
                      class="btn green-btn"
                      id="addCount"
                      type="button"
                    >
                      {" "}
                      Copy from Other Menu Item
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ModelContainer
        title={`Copy Modifier`}
        open={copyModifierModal}
        submitModal={copyModifierSubmit(submitCopyModifierModal)}
        closeModal={closeCopyModifierModal}
        is_loading={false}
      >
        <fieldset class="">
          <ul class="form-list label-group new-form">
            <GroupSelect
              label={"Menu Items"}
              name="menu_item_id"
              className="w-100"
              divClass="input-group col-md-7"
              onChange={(e) =>
                copyModifierChangeInputHandler("menu_item_id", e?.target?.value)
              }
              value={copyModifierInputForm?.menu_item_id}
              options={createSelectOptions(copy_modifier_details?.menu_items)}
              errorMsg={getErrorMsgForCopyModifier("menu_item_id")}
            />
            <GroupMultiSelect
              label={"Modifiers"}
              name="modifier_id"
              className="w-100"
              divClass="input-group col-md-7"
              onChange={(values) =>
                copyModifierChangeInputHandler("modifier_id", values)
              }
              value={copyModifierInputForm?.modifier_id}
              options={createMultiSelectOptions(
                copy_modifier_details?.modifiers
              )}
              errorMsg={getErrorMsgForCopyModifier("modifier_id")}
            />
          </ul>
        </fieldset>
      </ModelContainer>
      <ModelContainer
        title={`Add Pricing`}
        open={modifierItemModal}
        submitModal={modifierItemSubmit(submitModifierItemModal)}
        closeModal={closeModifierItemModal}
        is_loading={false}
      >
        <fieldset class="">
          <ul class="form-list label-group new-form">
            <GroupSelect
              label={"Modified Item?"}
              name="modified_item"
              className="w-100"
              divClass="input-group col-md-7"
              onChange={(e) =>
                modifierItemChangeInputHandler(
                  "modified_item",
                  e?.target?.value
                )
              }
              value={modifierItemInputForm?.modified_item}
              options={createSelectOptions(
                item_modifiers_details?.modified_item
              )}
              errorMsg={getErrorMsgForModifierItem("modified_item")}
            />
            <GroupInput
              label={"Modifier Name"}
              name="modifier_name"
              className="required"
              labelClass="required"
              divClass="input-group"
              placeholder="Modifier Name"
              onChange={(e) =>
                modifierItemChangeInputHandler(
                  "modifier_name",
                  e?.target?.value
                )
              }
              value={modifierItemInputForm?.modifier_name}
              errorMsg={getErrorMsgForModifierItem("modifier_name")}
            />

            <GroupSelect
              label={"Modifier Group"}
              name="modifier_group_id"
              className="w-100"
              divClass="input-group col-md-7"
              onChange={(e) =>
                modifierItemChangeInputHandler(
                  "modifier_group_id",
                  e?.target?.value
                )
              }
              value={modifierItemInputForm?.modifier_group_id}
              options={createSelectOptions(
                item_modifiers_details?.modifier_groups
              )}
              errorMsg={getErrorMsgForModifierItem("modifier_group_id")}
            />
            <GroupSelectTwo
              label={"Menu Item Name"}
              name="menu_item_id"
              className="required w-100"
              labelClass="required"
              divClass="input-group"
              onSelect={(e) => {
                modifierItemChangeInputHandler(
                  "menu_item_id",
                  e?.target?.value
                );
              }}
              value={modifierItemInputForm?.menu_item_id}
              empty={"Select"}
              options={createSelectTwoOptions(
                item_modifiers_details?.comp_menu_items
              )}
              errorMsg={getErrorMsgForModifierItem("menu_item_id")}
            />
            <GroupSelect
              label={"Modifier Type"}
              name="type"
              className="w-100"
              divClass="input-group col-md-7"
              onChange={(e) =>
                modifierItemChangeInputHandler("type", e?.target?.value)
              }
              value={modifierItemInputForm?.type}
              options={createSelectOptions(
                modifierItemInputForm?.modified_item == "component"
                  ? item_modifiers_details?.item_types
                  : { menu_item: "Menu Item" }
              )}
              errorMsg={getErrorMsgForModifierItem("type")}
            />
            <GroupSelect
              label={"Action"}
              name="action"
              className="w-100"
              divClass="input-group col-md-7"
              onChange={(e) =>
                modifierItemChangeInputHandler("action", e?.target?.value)
              }
              value={modifierItemInputForm?.action}
              options={createSelectOptions(item_modifiers_details?.action_type)}
              errorMsg={getErrorMsgForModifierItem("action")}
            />
            {modifierItemInputForm?.type == "recipe" && (
              <GroupSelectTwo
                label={"Component Item Name"}
                name="recipe_id"
                className="required w-100"
                labelClass="required"
                divClass="input-group"
                onSelect={(e) => {
                  modifierItemChangeInputHandler("recipe_id", e?.target?.value);
                }}
                value={modifierItemInputForm?.recipe_id}
                empty={"Select"}
                options={createSelectTwoOptions(
                  item_modifiers_details?.recipes
                )}
                errorMsg={getErrorMsgForModifierItem("recipe_id")}
              />
            )}

            {modifierItemInputForm?.type == "ingredient" && (
              <GroupSelectTwo
                label={"Component Item Name"}
                name="ingredient_id"
                className="required w-100"
                labelClass="required"
                divClass="input-group"
                onSelect={(e) => {
                  modifierItemChangeInputHandler(
                    "ingredient_id",
                    e?.target?.value
                  );
                }}
                value={modifierItemInputForm?.ingredient_id}
                empty={"Select"}
                options={createSelectTwoOptions(
                  item_modifiers_details?.ingredients
                )}
                errorMsg={getErrorMsgForModifierItem("ingredient_id")}
              />
            )}
            {modifierItemInputForm?.type == "menu_item" && (
              <GroupSelectTwo
                label={"Component Item Name"}
                name="bundle_menu_item_id"
                className="required w-100"
                labelClass="required"
                divClass="input-group"
                onSelect={(e) => {
                  modifierItemChangeInputHandler(
                    "bundle_menu_item_id",
                    e?.target?.value
                  );
                }}
                value={modifierItemInputForm?.bundle_menu_item_id}
                empty={"Select"}
                options={createSelectTwoOptions(
                  item_modifiers_details?.bund_menu_items
                )}
                errorMsg={getErrorMsgForModifierItem("bundle_menu_item_id")}
              />
            )}
            {modifierItemInputForm?.type == "recipe" && (
              <>
                <GroupInput
                  label={"Number of Servings Used"}
                  name="number_of_servings"
                  className="required"
                  labelClass="required"
                  divClass="input-group"
                  placeholder="Number of Servings Used"
                  onChange={(e) =>
                    modifierItemChangeInputHandler(
                      "number_of_servings",
                      e?.target?.value
                    )
                  }
                  value={modifierItemInputForm?.number_of_servings}
                  errorMsg={getErrorMsgForModifierItem("number_of_servings")}
                />
              </>
            )}
            {modifierItemInputForm?.type == "ingredient" && (
              <>
                <GroupSelect
                  label={"Measurement Choice"}
                  name="measurement_choice_id"
                  className="required"
                  labelClass="required"
                  divClass="input-group"
                  onChange={(e) =>
                    modifierItemChangeInputHandler(
                      "measurement_choice_id",
                      e?.target?.value
                    )
                  }
                  value={modifierItemInputForm?.measurement_choice_id}
                  empty={"Measurement Choice"}
                  options={createSelectOptions(
                    item_modifiers_details?.measurementChoices
                  )}
                  errorMsg={getErrorMsgForModifierItem("measurement_choice_id")}
                />
                {modifierItemInputForm?.measurement_choice_id == 1 && (
                  <>
                    <GroupSelect
                      label={"Measurement Unit"}
                      name="measurement_unit_id"
                      className="required"
                      labelClass="required"
                      divClass="input-group"
                      onChange={(e) =>
                        modifierItemChangeInputHandler(
                          "measurement_unit_id",
                          e?.target?.value
                        )
                      }
                      value={modifierItemInputForm?.measurement_unit_id}
                      empty={"Select"}
                      options={createSelectOptions(
                        measurement_unit_details?.data
                      )}
                      errorMsg={getErrorMsgForModifierItem(
                        "measurement_unit_id"
                      )}
                    />
                    <GroupInput
                      label={"Unit Price"}
                      name="unit_price"
                      className="required"
                      labelClass="required"
                      divClass="input-group"
                      // onChange={(e) =>
                      //   modifierItemChangeInputHandler(
                      //
                      //     "unit_price",
                      //     e?.target?.value
                      //   )
                      // }
                      disabled={true}
                      value={modifierItemInputForm?.unit_price}
                      errorMsg={getErrorMsgForModifierItem("unit_price")}
                    />
                    <GroupInput
                      label={"Unit Amount"}
                      name="unit_amount"
                      className="required"
                      labelClass="required"
                      divClass="input-group"
                      onChange={(e) =>
                        modifierItemChangeInputHandler(
                          "unit_amount",
                          e?.target?.value
                        )
                      }
                      value={modifierItemInputForm?.unit_amount}
                      errorMsg={getErrorMsgForModifierItem("unit_amount")}
                    />
                    <GroupInput
                      label={"Item Component Cost"}
                      name="unit_cost"
                      className="required"
                      labelClass="required"
                      divClass="input-group"
                      // onChange={(e) =>
                      //   modifierItemChangeInputHandler(
                      //
                      //     "unit_cost",
                      //     e?.target?.value
                      //   )
                      // }
                      disabled={true}
                      value={modifierItemInputForm?.unit_cost}
                      errorMsg={getErrorMsgForModifierItem("unit_cost")}
                    />
                  </>
                )}
                {modifierItemInputForm?.measurement_choice_id == 2 && (
                  <>
                    <h5>Inventory Measurement Amount</h5>
                    <GroupSelect
                      label={"Measurement Unit"}
                      name="temp_measurement_unit_id"
                      className="required"
                      labelClass="required"
                      divClass="input-group"
                      onChange={(e) =>
                        modifierItemChangeInputHandler(
                          "temp_measurement_unit_id",
                          e?.target?.value
                        )
                      }
                      value={modifierItemInputForm?.temp_measurement_unit_id}
                      empty={"Select"}
                      options={createSelectOptions(
                        measurement_unit_details?.data
                      )}
                      errorMsg={getErrorMsgForModifierItem(
                        "temp_measurement_unit_id"
                      )}
                    />
                    <GroupInput
                      label={"Unit Price"}
                      name="temp_unit_price"
                      className="required"
                      labelClass="required"
                      divClass="input-group"
                      // onChange={(e) =>
                      //   modifierItemChangeInputHandler(
                      //
                      //     "temp_unit_price",
                      //     e?.target?.value
                      //   )
                      // }
                      disabled={true}
                      value={modifierItemInputForm?.temp_unit_price}
                      errorMsg={getErrorMsgForModifierItem("temp_unit_price")}
                    />
                    <GroupInput
                      label={"Conversion Multiplier"}
                      name="conversion_multiplier"
                      className="required"
                      labelClass="required"
                      divClass="input-group"
                      onChange={(e) =>
                        checkNull(
                          item_modifiers_details?.multiplier_detail?.multiplier,
                          false
                        )
                          ? null
                          : modifierItemChangeInputHandler(
                              "conversion_multiplier",
                              e?.target?.value
                            )
                      }
                      value={modifierItemInputForm?.conversion_multiplier}
                      readOnly={
                        checkNull(
                          item_modifiers_details?.multiplier_detail?.multiplier,
                          false
                        )
                          ? true
                          : false
                      }
                      errorMsg={getErrorMsgForModifierItem(
                        "conversion_multiplier"
                      )}
                    />
                    <h5>Menu Item Measurement Amount</h5>
                    <GroupSelect
                      label={"Measurement Unit"}
                      name="measurement_unit_id"
                      className="required"
                      labelClass="required"
                      divClass="input-group"
                      onChange={(e) =>
                        modifierItemChangeInputHandler(
                          "measurement_unit_id",
                          e?.target?.value
                        )
                      }
                      value={modifierItemInputForm?.measurement_unit_id}
                      empty={"Select"}
                      options={createSelectOptions(
                        item_modifiers_details?.servingUnits_only_name
                      )}
                      errorMsg={getErrorMsgForModifierItem(
                        "measurement_unit_id"
                      )}
                    />
                    <GroupInput
                      label={"Unit Price"}
                      name="unit_price"
                      className="required"
                      labelClass="required"
                      divClass="input-group"
                      onChange={(e) =>
                        modifierItemChangeInputHandler(
                          "unit_price",
                          e?.target?.value
                        )
                      }
                      readOnly={
                        checkNull(
                          item_modifiers_details?.multiplier_detail?.multiplier,
                          false
                        )
                          ? true
                          : false
                      }
                      value={modifierItemInputForm?.unit_price}
                      errorMsg={getErrorMsgForModifierItem("unit_price")}
                    />
                  </>
                )}
              </>
            )}
            <GroupInput
              label={"Amount Used"}
              name="amount_used"
              className="required"
              labelClass="required"
              divClass="input-group"
              placeholder="Amount Used"
              onChange={(e) =>
                modifierItemChangeInputHandler("amount_used", e?.target?.value)
              }
              value={modifierItemInputForm?.amount_used}
              errorMsg={getErrorMsgForModifierItem("amount_used")}
            />
            <GroupInput
              label={"Unit Cost"}
              name="unit_cost"
              className="required"
              labelClass="required"
              divClass="input-group"
              placeholder="Unit Cost"
              onChange={(e) => {
                if (
                  !(
                    (modifierItemInputForm?.type == "recipe" &&
                      checkNull(item_ca_details?.rCpr, false)) ||
                    (modifierItemInputForm?.type == "ingredient" &&
                      checkNull(
                        modifierItemInputForm?.measurement_choice_id,
                        false
                      ) &&
                      modifierItemInputForm?.measurement_choice_id == 2) ||
                    (modifierItemInputForm?.type == "menu_item" &&
                      checkArray(item_modifiers_details?.cost_per_menu_item) &&
                      item_modifiers_details?.cost_per_menu_item?.[0]?.id ==
                        modifierItemInputForm?.bundle_menu_item_id)
                  )
                ) {
                  modifierItemChangeInputHandler("unit_cost", e?.target?.value);
                }
              }}
              disabled={
                (modifierItemInputForm?.type == "recipe" &&
                  checkNull(item_ca_details?.rCpr, false)) ||
                (modifierItemInputForm?.type == "ingredient" &&
                  checkNull(
                    modifierItemInputForm?.measurement_choice_id,
                    false
                  ) &&
                  modifierItemInputForm?.measurement_choice_id == 2) ||
                (modifierItemInputForm?.type == "menu_item" &&
                  checkArray(item_modifiers_details?.cost_per_menu_item) &&
                  item_modifiers_details?.cost_per_menu_item?.[0]?.id ==
                    modifierItemInputForm?.bundle_menu_item_id)
              }
              value={modifierItemInputForm?.unit_cost}
              errorMsg={getErrorMsgForModifierItem("unit_cost")}
            />
            <GroupInput
              label={"Modifier Price"}
              name="modifier_price"
              className="required"
              labelClass="required"
              divClass="input-group"
              placeholder="Modifier Price"
              onChange={(e) =>
                modifierItemChangeInputHandler(
                  "modifier_price",
                  e?.target?.value
                )
              }
              value={modifierItemInputForm?.modifier_price}
              errorMsg={getErrorMsgForModifierItem("modifier_price")}
            />
          </ul>
        </fieldset>
      </ModelContainer>
    </>
  );
};

export default BundledModifiers;
